import { Link, graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import YearMenu from "./yearMenu"
import { useLocation } from "@reach/router"

export default function Menu() {
  const pathName = useLocation().href
  return (
    <div>
      <div className="menu">
        <ul>
          <li key="/about/">
            {" "}
            <h2>
              <Link
                to="/about/"
                style={{
                  color: "black",
                  textDecoration: "none",
                  ...(typeof window !== "undefined" &&
                  pathName.split("/").includes("about")
                    ? { borderTop: ".2rem grey solid" }
                    : null),
                }}
              >
                about
              </Link>{" "}
            </h2>
          </li>
          <li key="/recent-work/">
            {" "}
            <h2>
              <Link
                to="/recent-work/"
                style={{
                  color: "black",
                  textDecoration: "none",
                  ...(typeof window !== "undefined" &&
                  pathName.split("/").includes("recent-work")
                    ? { borderTop: ".2rem grey solid" }
                    : null),
                }}
              >
                recent-work
              </Link>
            </h2>
          </li>
          <li key="/news/">
            {" "}
            <h2>
              <a
                href="http://eepurl.com/iDzD1U"
                target="_blank"
                style={{
                  textDecoration: "none",
                  color: "black",
                }}
              >
                news
              </a>
            </h2>
          </li>
          <li key="/archive/">
            {" "}
            <h2>
              <Link
                to="/archive"
                style={{
                  color: "black",
                  textDecoration: "none",
                  ...(typeof window !== "undefined" &&
                  pathName.split("/").includes("archive")
                    ? { borderTop: ".2rem grey solid" }
                    : null),
                }}
              >
                archive
              </Link>
            </h2>
          </li>
        </ul>
      </div>
    </div>
  )
}
